"use client";

import Login from "@casino/legacy/client/components/Auth/Login";
import Register from "@casino/legacy/client/components/Auth/Register";
import { useGamePageData } from "@casino/ui/Games/hooks";
import type { AuthTab } from "@casino/ui/Games/hooks/useAuthGate";
import { Tabs, TabsContent } from "@workspace/frontend-ui";
import type { FC } from "react";
import { useState } from "react";
import AuthFormProviders from "./AuthFormProviders";
import AuthTabContext from "./AuthTabContext";
import ProfileFormTabsHeader from "./ProfileFormTabsHeader";

type Props = {
  onSuccess?: () => void;
  defaultTab?: AuthTab;
};

// Without onSuccess the submit button spins forever; without isPopover Register hard-navigates away.
const ProfileForm: FC<Props> = ({ onSuccess, defaultTab }) => {
  const { isRegistrationDisabled } = useGamePageData();
  // Controlled rather than Tabs' defaultValue so the bottom links can move it — see AuthTabContext.
  const [activeTab, setActiveTab] = useState<AuthTab>(
    isRegistrationDisabled ? "login" : (defaultTab ?? "login"),
  );

  return (
    <AuthFormProviders>
      <AuthTabContext.Provider value={setActiveTab}>
        <Tabs
          value={activeTab}
          onValueChange={(value) => setActiveTab(value as AuthTab)}
          className="w-full h-[80svh] overflow-y-scroll no-scrollbar"
        >
          <ProfileFormTabsHeader />
          <TabsContent value="login">
            <Login isPopover onSuccess={onSuccess} />
          </TabsContent>
          {!isRegistrationDisabled && (
            <TabsContent value="register">
              <Register isPopover onSuccess={onSuccess} />
            </TabsContent>
          )}
        </Tabs>
      </AuthTabContext.Provider>
    </AuthFormProviders>
  );
};

export default ProfileForm;
